package org.example.project.client.time

import kotlin.time.Clock
import kotlin.time.Instant

object AppTime {
    /**
     * Parses an ISO-8601 timestamp string using standard kotlin.time.Instant.parse.
     * Throws IllegalArgumentException without echoing sensitive payload.
     */
    fun parseIsoToEpochMillis(isoString: String): Long {
        val trimmed = isoString.trim()
        require(trimmed.isNotEmpty()) { "Timestamp string cannot be empty" }
        val instant = try {
            Instant.parse(trimmed)
        } catch (_: Exception) {
            throw IllegalArgumentException("Invalid ISO-8601 timestamp format")
        }
        return instant.toEpochMilliseconds()
    }
}
